import React, { useEffect, useState } from "react"
import { Input, message, Modal, Tooltip } from "antd"
import dayjs from "dayjs"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import RejectModal from "../Modal/RejectModal"
import ModalDetail from "../Modal/ModalDetail"
import STORAGE from "src/lib/storage"
import ProposalService from "src/services/ProposalService"
import TransactionService from "src/services/TransactionService"
import CreateTransactionModal from "../Modal/CreateTransactionModal"
import ApproveModal from "../Modal/ApproveModal"

import {
  InputSearchStyle,
  PaginationStyle,
} from "src/pages/ADMIN/HumanResource/styled"
import SvgIcon from "src/components/SvgIcon"
import ToolBarCustomLayer from "src/components/ToolBarCustom/ToolBarCustomLayer"
import Filter from "./Filter"

const STATUS_LIST = [
  { id: "1", name: "Chờ duyệt" },
  { id: "2", name: "Đã duyệt" },
  { id: "3", name: "Từ chối" },
]

const DISCOUNT_TYPE_LIST = [
  { key: "percent", name: "Chiết khấu %" },
  { key: "fixed", name: "Chiết khấu số tiền" },
]

const ActionItem = ({ icon, label, onClick }) => (
  <div
    onClick={e => {
      e.stopPropagation()
      onClick()
    }}
    className="action-item"
  >
    <IconBase name={icon} />
    <span>{label}</span>
  </div>
)

const getStatusName = id => STATUS_LIST.find(s => s.id === id)?.name || ""
const getDiscountTypeName = key =>
  DISCOUNT_TYPE_LIST.find(d => d.key === key)?.name || ""

const DepositeWithdrawalTable = ({
  // type,
  refreshData,
  tabStatus,
  statusApproval,
  statusRefuses,
  onApprove,
  onCancel,
  permissions,
}) => {
  const [data, setData] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    // total: 0,
  })
  const [summary, setSummary] = useState({
    total: 0,
    amountIn: 0,
    amountOut: 0,
  })

  const [viewModalVisible, setViewModalVisible] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [rejectModalVisible, setRejectModalVisible] = useState(false)

  const [selectedRecord, setSelectedRecord] = useState(null)
  const [rejectReason, setRejectReason] = useState("")
  const [refresh, setRefresh] = useState(false)
  const [approveModalVisible, setApproveModalVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [filter, setFilter] = useState({})
  const [openPopupKey, setOpenPopupKey] = useState(null)
  const [status, setStatus] = useState()

  useEffect(() => {
    // console.log("filter", filter);
    fetchData(searchValue, filter)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    // console.log(pagination)
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(searchValue, filter)
      }
    }
  }, [filter, searchValue, refresh, tabStatus, refreshData])
  const fetchData = async (keyword, filter) => {
    setLoading(true)
    // if(statusApproval){
    //     filter = {
    //       ...filter,
    //       status: statusApproval,
    //     }
    //   }
    //   if(statusRefuses){
    //     filter = {
    //       ...filter,
    //       status: statusRefuses,
    //     }
    //   }
    try {
      const res = await TransactionService.getListTransaction({
        page: pagination.current,
        per_page: pagination.pageSize,
        type: tabStatus,
        // status:status,
        filter: {
          ...filter,
          // status: statusApproval
        },
        keyword,
      })

      if (res.success) {
        // console.log(res.success, "trán table")
        // const { amount } = res.success
        const total = Number(res?.success?.total)
        // const amountIn = Number(res?.success?.amount?.in).toLocaleString(
        //   "en-US",
        // )
        // const amountOut = Number(res?.success?.status?.out).toLocaleString(
        //   "en-US",
        // )
        const approved = Number(
          res?.success?.status?.approved_total,
        ).toLocaleString("en-US")
        const pending = Number(
          res?.success?.status?.pending_total,
        ).toLocaleString("en-US")
        const reject = Number(
          res?.success?.status?.refuse_total,
        ).toLocaleString("en-US")

        const aprovalTime = res?.success?.status?.approved
        const pendingTime = res?.success?.status?.pending
        const rejectTime = res?.success?.status?.refuse
        const transformedData = res.success.data.map(item => ({
          ...item,
          create_at: dayjs(item.create_at).format("DD-MM-YYYY"),
          createBy: item.createby?.fullname || "",
          status_name: getStatusName(item.status),
          discount_type: getDiscountTypeName(item.discount_type),
        }))

        // const total = res?.success?.total;

        // setPagination(prev => ({
        //   ...prev,
        //   // current,
        //   // pageSize: perPage,
        //   total: total,
        // }));
        setPagination({
          ...pagination,
          // current,
          // pageSize: perPage,
          total: total,
        })
        setData(transformedData)
        setSummary({
          total,
          // amountIn: amountIn,
          // amountOut: amountOut,
          approved: approved,
          pending,
          reject,
          aprovalTime,
          pendingTime,
          rejectTime,
        })
      }
    } catch (err) {
      message.error("Lỗi khi tải dữ liệu: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = value => {
    setSearchValue(value)
    // fetchData(value)
  }

  const handleAction = (action, record) => {
    setSelectedRecord(record)
    switch (action) {
      case "view":
        setViewModalVisible(true)
        break
      case "edit":
        setEditModalVisible(true)
        break
      case "approve":
        CB1({
          title: `Bạn có chắc chắn muốn duyệt mã giao dịch <strong>${record?.code}</strong> của khách hàng <strong>${record?.customer?.fullname}</strong> không?`,
          icon: "check-circle",
          okText: "Duyệt",
          onOk: async close => {
            await approveProposal(record.ID)
            close()
          },
        })
        break

      case "reject":
        setRejectModalVisible(true)
        // rejectProposal(record.ID)
        // setRefresh(prev => !prev)
        break
      default:
        break
    }
  }

  const approveProposal = async record => {
    setLoading(true)
    try {
      const res = await TransactionService.browseTransaction(record)

      if (res.message && res.message.includes("thành công")) {
        await onApprove?.(record.ID) // thêm await ở đây nếu là async
        onCancel?.()
        message.success(res.message)
        setRefresh(prev => !prev)
      } else {
        message.error("Không thể duyệt phiếu")
      }
    } catch (err) {
      console.error("duyệt lỗi:", err)
      message.error("Lỗi khi duyệt: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const rejectProposal = async () => {
    // if (!rejectReason.trim())
    //   return message.warning("Vui lòng nhập lý do từ chối")

    setLoading(true)
    try {
      // console.log(rejectReason, "@@@")
      const res = await TransactionService.refuseTransaction(
        selectedRecord.ID,
        {
          note: rejectReason,
        },
      )
      if (res.message.includes("thành công")) {
        message.success("Đã từ chối thành công")
        setRejectModalVisible(false)
        setRejectReason("")
        setRefresh(prev => !prev)
      } else {
        message.error("Không thể từ chối phiếu")
      }
    } catch (err) {
      message.error("Lỗi khi từ chối: " + err.message)
    } finally {
      setLoading(false)
    }
  }
  const formatCurrency = value =>
    new Intl.NumberFormat({ style: "currency", currency: "VND" }).format(
      value || 0,
    )

  const columns = [
    // { title: "STT", render: (_, __, i) => i + 1 },
    {
      title: "Mã giao dịch",
      dataIndex: "code",
      align: "center",
    },

    ...(tabStatus === "history"
      ? [
          {
            title: "Mã xuất kho",
            dataIndex: "export",
            align: "center",
            render: exportCode => exportCode?.export_code || "",
          },
        ]
      : []),
    {
      title: "Khách hàng",
      dataIndex: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    ...(tabStatus === "2"
      ? [
          {
            title: "Số tài khoản",
            dataIndex: "customer",
            render: customer => customer?.account_no || "",
            align: "center",
          },
          {
            title: "Ngân hàng",
            dataIndex: "customer",
            render: customer => customer?.bank?.name || "",
            align: "center",
          },
          {
            title: "Chủ tài khoản",
            dataIndex: "customer",
            render: customer => customer?.beneficiary || "",
            align: "center",
          },
        ]
      : []),
    {
      title: "Số tiền giao dịch",
      dataIndex: "amount",
      render: amount => formatCurrency(amount),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    // {
    //   title: "Số tiền vào",
    //   dataIndex: "amount_in",
    //   render: amount => formatCurrency(amount),
    //   align: "center",
    // },
    // {
    //   title: "Số tiền ra",
    //   dataIndex: "amount_out",
    //   render: amount => formatCurrency(amount),
    //   align: "center",
    // },
    // {
    //   title: "Số dư tài khoản của khách hàng",
    //   dataIndex: "customer",
    //   render: (customer) => formatCurrency(customer?.balance)
    // },
    {
      title: "Số dư hiện tại",
      dataIndex: "balance",
      render: balance => formatCurrency(balance),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: status => {
        switch (String(status)) {
          case "0":
            return (
              <span style={{ color: "orange", fontWeight: "bold" }}>
                Chờ duyệt
              </span>
            )
          case "1":
            return (
              <span style={{ color: "green", fontWeight: "bold" }}>
                Đã duyệt
              </span>
            )
          case "2":
            return (
              <span style={{ color: "red", fontWeight: "bold" }}>Từ chối</span>
            )
          // case "3":
          //   return (
          //     <span style={{ color: "blue", fontWeight: "bold" }}>Đã kí</span>
          //   )
          default:
            return (
              <span style={{ color: "gray", fontWeight: "bold" }}>
                Không xác định
              </span>
            )
        }
      },
    },
    {
      title: "Ngày yêu cầu",
      dataIndex: "created_at",
      render: text =>
        text && dayjs(text).isValid() ? dayjs(text).format("DD/MM/YYYY") : "",
      align: "center",
    },
    {
      title: "Ngày duyệt",
      dataIndex: "approved_at",
      render: text =>
        text && dayjs(text).isValid() ? dayjs(text).format("DD/MM/YYYY") : "",
      align: "center",
    },
    {
      title: "Người duyệt",
      dataIndex: "approved",
      render: approved => approved?.fullname || "",
      align: "center",
    },

    {
      title: <Tooltip title="Hành động">_</Tooltip>,
      key: "action",
      align: "center",
      // fixed: "right",
      render: (_, record) => {
        const isPending = record.status === 0
        return (
          <PopupAction>
            {permissions.includes("wallet.detail") ? (
              <ActionItem
                icon="eye"
                label="Xem chi tiết"
                onClick={() => handleAction("view", record)}
              />
            ) : (
              <React.Fragment />
            )}

            {isPending ? (
              <>
                {permissions.includes("wallet.browse") ? (
                  <ActionItem
                    icon="approval"
                    label="Duyệt"
                    onClick={() => handleAction("approve", record)}
                    loading={loading === record.id}
                  />
                ) : (
                  <React.Fragment />
                )}
                {permissions.includes("wallet.refuse") ? (
                  <ActionItem
                    icon="cancelApproval"
                    label="Từ chối"
                    onClick={() => handleAction("reject", record)}
                  />
                ) : (
                  <React.Fragment />
                )}
              </>
            ) : (
              <></>
            )}
          </PopupAction>
        )
      },
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const itemsLeft = [
    {
      key: "filter",
      component: (
        <Filter
          setFilter={setFilter}
          // setStatus={setStatus}
          // tabStatus={statusApproval || statusRefuses}
        />
      ),
    },
  ]

  const itemsRight = [
    {
      key: "input_search",
      component: (
        <InputSearchStyle>
          <Input
            className="custom-input"
            maxLength={50}
            placeholder="Tên khách hàng"
            allowClear
            onClear={e => setSearchValue("")}
            // value={searchValue}
            // onChange={(e) => setSearchValue(e.target.value)}
            onPressEnter={e => setSearchValue(e.target.value)}
          />
          <div className="custom-icon-search">
            <SvgIcon
              name="searchStatistic"
              onClick={() => handleSearch(searchValue)}
            />
          </div>
        </InputSearchStyle>
      ),
    },
  ]
  // console.log(tabStatus,"tabstt")
  return (
    <>
      <ToolBarCustomLayer itemsLeft={itemsLeft} itemsRight={itemsRight} />
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: " #007BFF" }}>
          <strong>Giao dịch thành công: {summary.total}</strong>
        </div>
        {tabStatus == 5 ? (
          <React.Fragment />
        ) : (
          <div style={{ padding: "0 5px", color: " #007BFF" }}>
            <strong>
              Chờ duyệt: {summary.pending} ({summary.pendingTime})
            </strong>
          </div>
        )}

        <div style={{ padding: "0 5px", color: "green" }}>
          <strong>
            Đã duyệt: {summary.approved} ({summary.aprovalTime})
          </strong>
        </div>
        {tabStatus == 5 ? (
          <React.Fragment />
        ) : (
          <div style={{ padding: "0 5px", color: "red" }}>
            <strong>
              Từ chối: {summary.reject} ({summary.rejectTime})
            </strong>
          </div>
        )}
      </div>

      <TableCustom
        noMrb
        isPrimary
        columns={columns}
        dataSource={data}
        loading={isLoading}
        rowKey={record => record.orderId}
        footerLeft={<div className="d-flex mt-20" />}
        scroll={{ x: 1300 }}
        textEmpty="Không có dữ liệu!"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
      />

      {viewModalVisible && (
        <ModalDetail
          visible={viewModalVisible}
          onClose={() => setViewModalVisible(false)}
          record={selectedRecord}
        />
      )}

      {rejectModalVisible && (
        <RejectModal
          open={rejectModalVisible}
          onCancel={() => setRejectModalVisible(false)}
          onConfirm={rejectProposal}
          setRejectReason={setRejectReason}
        />
      )}

      {/* <ApproveModal
            visible={approveModalVisible}
            onCancel={() => setApproveModalVisible(false)}
            onApprove={approveProposal}
            record={selectedRecord}
          /> */}
    </>
  )
}

export default DepositeWithdrawalTable
